/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { EmployerStatisticsResponse } from '../models';
// @ts-ignore
import type { GetAdminAiGuideStatisticsResponse } from '../models';
// @ts-ignore
import type { GetAdminAiUsageStatisticsResponse } from '../models';
// @ts-ignore
import type { GetAdminChatStatisticsResponse } from '../models';
// @ts-ignore
import type { GetAdminCompetitionStatisticsResponse } from '../models';
// @ts-ignore
import type { GetAdminCreditsStatisticsActionTypeResponse } from '../models';
// @ts-ignore
import type { GetAdminCreditsStatisticsResponse } from '../models';
// @ts-ignore
import type { GetAdminEmailStatisticsResponse } from '../models';
// @ts-ignore
import type { GetAdminExternalJobStatisticsResponse } from '../models';
// @ts-ignore
import type { GetAdminGemsStatisticsResponse } from '../models';
// @ts-ignore
import type { GetAdminJobChatStatisticsResponse } from '../models';
// @ts-ignore
import type { GetAdminJobPostedStatisticsResponse } from '../models';
// @ts-ignore
import type { GetAdminJobProfileInvitesStatisticsResponse } from '../models';
// @ts-ignore
import type { GetAdminJobStatisticsResponse } from '../models';
// @ts-ignore
import type { GetAdminPlacementPartnerStatisticsResponse } from '../models';
// @ts-ignore
import type { GetAdminPreJobAnalysisStatisticsResponse } from '../models';
// @ts-ignore
import type { GetAdminQuestionAttemptStatisticsResponse } from '../models';
// @ts-ignore
import type { GetAdminQuestionCreatedStatisticsResponse } from '../models';
// @ts-ignore
import type { GetAdminReferralStatisticsResponse } from '../models';
// @ts-ignore
import type { GetAdminResumeStatisticsResponse } from '../models';
// @ts-ignore
import type { GetAdminSkilltestStatisticsResponse } from '../models';
// @ts-ignore
import type { GetAlgoLogsStatisticsResponse } from '../models';
// @ts-ignore
import type { JobApplicantsStatistics } from '../models';
// @ts-ignore
import type { LearnerActivityStatisticsResponse } from '../models';
// @ts-ignore
import type { OtpFunnelStatisticsResponse } from '../models';
// @ts-ignore
import type { PaymentFunnelStatisticsResponse } from '../models';
// @ts-ignore
import type { PlayArenaStatisticsResponse } from '../models';
// @ts-ignore
import type { PremiumSubscriptionStatisticsResponse } from '../models';
// @ts-ignore
import type { SignupPageStatistics } from '../models';
// @ts-ignore
import type { SignupStatistics } from '../models';
/**
 * StatisticsApiApi - axios parameter creator
 */
export const StatisticsApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetAdminAiGuideStatistics: async (endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/ai_guide/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (granularity !== undefined) {
                localVarQueryParameter['granularity'] = granularity;
            }

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (userType !== undefined) {
                localVarQueryParameter['user_type'] = userType;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetAdminAiUsageStatistics: async (endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/ai-usage/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (granularity !== undefined) {
                localVarQueryParameter['granularity'] = granularity;
            }

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (userType !== undefined) {
                localVarQueryParameter['user_type'] = userType;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetAdminChatStatistics: async (endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/chat/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (granularity !== undefined) {
                localVarQueryParameter['granularity'] = granularity;
            }

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (userType !== undefined) {
                localVarQueryParameter['user_type'] = userType;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetAdminCompetitionStatistics: async (endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/competition/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (granularity !== undefined) {
                localVarQueryParameter['granularity'] = granularity;
            }

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (userType !== undefined) {
                localVarQueryParameter['user_type'] = userType;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetAdminCreditsStatistics: async (endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/credits/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (granularity !== undefined) {
                localVarQueryParameter['granularity'] = granularity;
            }

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (userType !== undefined) {
                localVarQueryParameter['user_type'] = userType;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetAdminCreditsStatisticsActionType: async (endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/credits/statistics/action_type`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (granularity !== undefined) {
                localVarQueryParameter['granularity'] = granularity;
            }

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (userType !== undefined) {
                localVarQueryParameter['user_type'] = userType;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetAdminEmailStatisticsByType: async (endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/email/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (granularity !== undefined) {
                localVarQueryParameter['granularity'] = granularity;
            }

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (userType !== undefined) {
                localVarQueryParameter['user_type'] = userType;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetAdminExternalJobStatistics: async (endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/external-jobs/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (granularity !== undefined) {
                localVarQueryParameter['granularity'] = granularity;
            }

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (userType !== undefined) {
                localVarQueryParameter['user_type'] = userType;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetAdminGemsStatistics: async (endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/gems/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (granularity !== undefined) {
                localVarQueryParameter['granularity'] = granularity;
            }

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (userType !== undefined) {
                localVarQueryParameter['user_type'] = userType;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetAdminJobChatStatistics: async (endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/job_chat/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (granularity !== undefined) {
                localVarQueryParameter['granularity'] = granularity;
            }

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (userType !== undefined) {
                localVarQueryParameter['user_type'] = userType;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetAdminJobPostedStatistics: async (endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/job-posted/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (granularity !== undefined) {
                localVarQueryParameter['granularity'] = granularity;
            }

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (userType !== undefined) {
                localVarQueryParameter['user_type'] = userType;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [jobId] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetAdminJobProfileInvitesStatistics: async (endDate?: string, granularity?: string, jobId?: string, platform?: string, startDate?: string, userType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/job_profile_invites/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (granularity !== undefined) {
                localVarQueryParameter['granularity'] = granularity;
            }

            if (jobId !== undefined) {
                localVarQueryParameter['job_id'] = jobId;
            }

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (userType !== undefined) {
                localVarQueryParameter['user_type'] = userType;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetAdminJobStatistics: async (endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/job/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (granularity !== undefined) {
                localVarQueryParameter['granularity'] = granularity;
            }

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (userType !== undefined) {
                localVarQueryParameter['user_type'] = userType;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetAdminLearnerActivityStatistics: async (endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/learner-activity/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (granularity !== undefined) {
                localVarQueryParameter['granularity'] = granularity;
            }

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (userType !== undefined) {
                localVarQueryParameter['user_type'] = userType;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetAdminOtpFunnelStatistics: async (endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/otp-funnel/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (granularity !== undefined) {
                localVarQueryParameter['granularity'] = granularity;
            }

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (userType !== undefined) {
                localVarQueryParameter['user_type'] = userType;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetAdminPaymentFunnelStatistics: async (endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/payment-funnel/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (granularity !== undefined) {
                localVarQueryParameter['granularity'] = granularity;
            }

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (userType !== undefined) {
                localVarQueryParameter['user_type'] = userType;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetAdminPlacementPartnerStatistics: async (endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/placement-partner/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (granularity !== undefined) {
                localVarQueryParameter['granularity'] = granularity;
            }

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (userType !== undefined) {
                localVarQueryParameter['user_type'] = userType;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetAdminPlayArenaStatistics: async (endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/play-arena/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (granularity !== undefined) {
                localVarQueryParameter['granularity'] = granularity;
            }

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (userType !== undefined) {
                localVarQueryParameter['user_type'] = userType;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetAdminPreJobAnalysisStatistics: async (endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/pre_job_analysis/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (granularity !== undefined) {
                localVarQueryParameter['granularity'] = granularity;
            }

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (userType !== undefined) {
                localVarQueryParameter['user_type'] = userType;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {StatisticsApiGetAdminPremiumSubscriptionStatisticsIntroOfferEnum} [introOffer] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetAdminPremiumSubscriptionStatistics: async (endDate?: string, granularity?: string, introOffer?: StatisticsApiGetAdminPremiumSubscriptionStatisticsIntroOfferEnum, platform?: string, startDate?: string, userType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/premium-subscriptions/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (granularity !== undefined) {
                localVarQueryParameter['granularity'] = granularity;
            }

            if (introOffer !== undefined) {
                localVarQueryParameter['intro_offer'] = introOffer;
            }

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (userType !== undefined) {
                localVarQueryParameter['user_type'] = userType;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetAdminQuestionCreatedStatistics: async (endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/question-created/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (granularity !== undefined) {
                localVarQueryParameter['granularity'] = granularity;
            }

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (userType !== undefined) {
                localVarQueryParameter['user_type'] = userType;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetAdminQuestionStatistics: async (endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/question-attempt/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (granularity !== undefined) {
                localVarQueryParameter['granularity'] = granularity;
            }

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (userType !== undefined) {
                localVarQueryParameter['user_type'] = userType;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetAdminReferralStatistics: async (endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/referral/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (granularity !== undefined) {
                localVarQueryParameter['granularity'] = granularity;
            }

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (userType !== undefined) {
                localVarQueryParameter['user_type'] = userType;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetAdminResumeStatistics: async (endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/resume/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (granularity !== undefined) {
                localVarQueryParameter['granularity'] = granularity;
            }

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (userType !== undefined) {
                localVarQueryParameter['user_type'] = userType;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetAdminSkillTestStatistics: async (endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/skill-test/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (granularity !== undefined) {
                localVarQueryParameter['granularity'] = granularity;
            }

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (userType !== undefined) {
                localVarQueryParameter['user_type'] = userType;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetAlgoLogsActivity: async (endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/algo-logs/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (granularity !== undefined) {
                localVarQueryParameter['granularity'] = granularity;
            }

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (userType !== undefined) {
                localVarQueryParameter['user_type'] = userType;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetEmployerActivity: async (endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/employer-activity/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (granularity !== undefined) {
                localVarQueryParameter['granularity'] = granularity;
            }

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (userType !== undefined) {
                localVarQueryParameter['user_type'] = userType;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetJobApplicantsSummary: async (endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/resume-xray/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (granularity !== undefined) {
                localVarQueryParameter['granularity'] = granularity;
            }

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (userType !== undefined) {
                localVarQueryParameter['user_type'] = userType;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetUserSignupsByPageUrl: async (endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/signup-page/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (granularity !== undefined) {
                localVarQueryParameter['granularity'] = granularity;
            }

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (userType !== undefined) {
                localVarQueryParameter['user_type'] = userType;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetUserSignupsByUtmSource: async (endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/signup-source/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (granularity !== undefined) {
                localVarQueryParameter['granularity'] = granularity;
            }

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (userType !== undefined) {
                localVarQueryParameter['user_type'] = userType;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StatisticsApiApi - functional programming interface
 */
export const StatisticsApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StatisticsApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statisticsApiGetAdminAiGuideStatistics(endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAdminAiGuideStatisticsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statisticsApiGetAdminAiGuideStatistics(endDate, granularity, platform, startDate, userType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatisticsApiApi.statisticsApiGetAdminAiGuideStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statisticsApiGetAdminAiUsageStatistics(endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAdminAiUsageStatisticsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statisticsApiGetAdminAiUsageStatistics(endDate, granularity, platform, startDate, userType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatisticsApiApi.statisticsApiGetAdminAiUsageStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statisticsApiGetAdminChatStatistics(endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAdminChatStatisticsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statisticsApiGetAdminChatStatistics(endDate, granularity, platform, startDate, userType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatisticsApiApi.statisticsApiGetAdminChatStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statisticsApiGetAdminCompetitionStatistics(endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAdminCompetitionStatisticsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statisticsApiGetAdminCompetitionStatistics(endDate, granularity, platform, startDate, userType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatisticsApiApi.statisticsApiGetAdminCompetitionStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statisticsApiGetAdminCreditsStatistics(endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAdminCreditsStatisticsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statisticsApiGetAdminCreditsStatistics(endDate, granularity, platform, startDate, userType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatisticsApiApi.statisticsApiGetAdminCreditsStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statisticsApiGetAdminCreditsStatisticsActionType(endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAdminCreditsStatisticsActionTypeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statisticsApiGetAdminCreditsStatisticsActionType(endDate, granularity, platform, startDate, userType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatisticsApiApi.statisticsApiGetAdminCreditsStatisticsActionType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statisticsApiGetAdminEmailStatisticsByType(endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAdminEmailStatisticsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statisticsApiGetAdminEmailStatisticsByType(endDate, granularity, platform, startDate, userType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatisticsApiApi.statisticsApiGetAdminEmailStatisticsByType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statisticsApiGetAdminExternalJobStatistics(endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAdminExternalJobStatisticsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statisticsApiGetAdminExternalJobStatistics(endDate, granularity, platform, startDate, userType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatisticsApiApi.statisticsApiGetAdminExternalJobStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statisticsApiGetAdminGemsStatistics(endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAdminGemsStatisticsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statisticsApiGetAdminGemsStatistics(endDate, granularity, platform, startDate, userType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatisticsApiApi.statisticsApiGetAdminGemsStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statisticsApiGetAdminJobChatStatistics(endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAdminJobChatStatisticsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statisticsApiGetAdminJobChatStatistics(endDate, granularity, platform, startDate, userType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatisticsApiApi.statisticsApiGetAdminJobChatStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statisticsApiGetAdminJobPostedStatistics(endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAdminJobPostedStatisticsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statisticsApiGetAdminJobPostedStatistics(endDate, granularity, platform, startDate, userType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatisticsApiApi.statisticsApiGetAdminJobPostedStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [jobId] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statisticsApiGetAdminJobProfileInvitesStatistics(endDate?: string, granularity?: string, jobId?: string, platform?: string, startDate?: string, userType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAdminJobProfileInvitesStatisticsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statisticsApiGetAdminJobProfileInvitesStatistics(endDate, granularity, jobId, platform, startDate, userType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatisticsApiApi.statisticsApiGetAdminJobProfileInvitesStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statisticsApiGetAdminJobStatistics(endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAdminJobStatisticsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statisticsApiGetAdminJobStatistics(endDate, granularity, platform, startDate, userType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatisticsApiApi.statisticsApiGetAdminJobStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statisticsApiGetAdminLearnerActivityStatistics(endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LearnerActivityStatisticsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statisticsApiGetAdminLearnerActivityStatistics(endDate, granularity, platform, startDate, userType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatisticsApiApi.statisticsApiGetAdminLearnerActivityStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statisticsApiGetAdminOtpFunnelStatistics(endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OtpFunnelStatisticsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statisticsApiGetAdminOtpFunnelStatistics(endDate, granularity, platform, startDate, userType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatisticsApiApi.statisticsApiGetAdminOtpFunnelStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statisticsApiGetAdminPaymentFunnelStatistics(endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentFunnelStatisticsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statisticsApiGetAdminPaymentFunnelStatistics(endDate, granularity, platform, startDate, userType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatisticsApiApi.statisticsApiGetAdminPaymentFunnelStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statisticsApiGetAdminPlacementPartnerStatistics(endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAdminPlacementPartnerStatisticsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statisticsApiGetAdminPlacementPartnerStatistics(endDate, granularity, platform, startDate, userType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatisticsApiApi.statisticsApiGetAdminPlacementPartnerStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statisticsApiGetAdminPlayArenaStatistics(endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlayArenaStatisticsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statisticsApiGetAdminPlayArenaStatistics(endDate, granularity, platform, startDate, userType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatisticsApiApi.statisticsApiGetAdminPlayArenaStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statisticsApiGetAdminPreJobAnalysisStatistics(endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAdminPreJobAnalysisStatisticsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statisticsApiGetAdminPreJobAnalysisStatistics(endDate, granularity, platform, startDate, userType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatisticsApiApi.statisticsApiGetAdminPreJobAnalysisStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {StatisticsApiGetAdminPremiumSubscriptionStatisticsIntroOfferEnum} [introOffer] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statisticsApiGetAdminPremiumSubscriptionStatistics(endDate?: string, granularity?: string, introOffer?: StatisticsApiGetAdminPremiumSubscriptionStatisticsIntroOfferEnum, platform?: string, startDate?: string, userType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PremiumSubscriptionStatisticsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statisticsApiGetAdminPremiumSubscriptionStatistics(endDate, granularity, introOffer, platform, startDate, userType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatisticsApiApi.statisticsApiGetAdminPremiumSubscriptionStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statisticsApiGetAdminQuestionCreatedStatistics(endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAdminQuestionCreatedStatisticsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statisticsApiGetAdminQuestionCreatedStatistics(endDate, granularity, platform, startDate, userType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatisticsApiApi.statisticsApiGetAdminQuestionCreatedStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statisticsApiGetAdminQuestionStatistics(endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAdminQuestionAttemptStatisticsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statisticsApiGetAdminQuestionStatistics(endDate, granularity, platform, startDate, userType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatisticsApiApi.statisticsApiGetAdminQuestionStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statisticsApiGetAdminReferralStatistics(endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAdminReferralStatisticsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statisticsApiGetAdminReferralStatistics(endDate, granularity, platform, startDate, userType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatisticsApiApi.statisticsApiGetAdminReferralStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statisticsApiGetAdminResumeStatistics(endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAdminResumeStatisticsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statisticsApiGetAdminResumeStatistics(endDate, granularity, platform, startDate, userType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatisticsApiApi.statisticsApiGetAdminResumeStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statisticsApiGetAdminSkillTestStatistics(endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAdminSkilltestStatisticsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statisticsApiGetAdminSkillTestStatistics(endDate, granularity, platform, startDate, userType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatisticsApiApi.statisticsApiGetAdminSkillTestStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statisticsApiGetAlgoLogsActivity(endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAlgoLogsStatisticsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statisticsApiGetAlgoLogsActivity(endDate, granularity, platform, startDate, userType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatisticsApiApi.statisticsApiGetAlgoLogsActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statisticsApiGetEmployerActivity(endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployerStatisticsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statisticsApiGetEmployerActivity(endDate, granularity, platform, startDate, userType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatisticsApiApi.statisticsApiGetEmployerActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statisticsApiGetJobApplicantsSummary(endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobApplicantsStatistics>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statisticsApiGetJobApplicantsSummary(endDate, granularity, platform, startDate, userType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatisticsApiApi.statisticsApiGetJobApplicantsSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statisticsApiGetUserSignupsByPageUrl(endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignupPageStatistics>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statisticsApiGetUserSignupsByPageUrl(endDate, granularity, platform, startDate, userType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatisticsApiApi.statisticsApiGetUserSignupsByPageUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [endDate] 
         * @param {string} [granularity] 
         * @param {string} [platform] 
         * @param {string} [startDate] 
         * @param {string} [userType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statisticsApiGetUserSignupsByUtmSource(endDate?: string, granularity?: string, platform?: string, startDate?: string, userType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignupStatistics>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statisticsApiGetUserSignupsByUtmSource(endDate, granularity, platform, startDate, userType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatisticsApiApi.statisticsApiGetUserSignupsByUtmSource']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StatisticsApiApi - factory interface
 */
export const StatisticsApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StatisticsApiApiFp(configuration)
    return {
        /**
         * 
         * @param {StatisticsApiApiStatisticsApiGetAdminAiGuideStatisticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetAdminAiGuideStatistics(requestParameters: StatisticsApiApiStatisticsApiGetAdminAiGuideStatisticsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetAdminAiGuideStatisticsResponse> {
            return localVarFp.statisticsApiGetAdminAiGuideStatistics(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StatisticsApiApiStatisticsApiGetAdminAiUsageStatisticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetAdminAiUsageStatistics(requestParameters: StatisticsApiApiStatisticsApiGetAdminAiUsageStatisticsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetAdminAiUsageStatisticsResponse> {
            return localVarFp.statisticsApiGetAdminAiUsageStatistics(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StatisticsApiApiStatisticsApiGetAdminChatStatisticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetAdminChatStatistics(requestParameters: StatisticsApiApiStatisticsApiGetAdminChatStatisticsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetAdminChatStatisticsResponse> {
            return localVarFp.statisticsApiGetAdminChatStatistics(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StatisticsApiApiStatisticsApiGetAdminCompetitionStatisticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetAdminCompetitionStatistics(requestParameters: StatisticsApiApiStatisticsApiGetAdminCompetitionStatisticsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetAdminCompetitionStatisticsResponse> {
            return localVarFp.statisticsApiGetAdminCompetitionStatistics(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StatisticsApiApiStatisticsApiGetAdminCreditsStatisticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetAdminCreditsStatistics(requestParameters: StatisticsApiApiStatisticsApiGetAdminCreditsStatisticsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetAdminCreditsStatisticsResponse> {
            return localVarFp.statisticsApiGetAdminCreditsStatistics(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StatisticsApiApiStatisticsApiGetAdminCreditsStatisticsActionTypeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetAdminCreditsStatisticsActionType(requestParameters: StatisticsApiApiStatisticsApiGetAdminCreditsStatisticsActionTypeRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetAdminCreditsStatisticsActionTypeResponse> {
            return localVarFp.statisticsApiGetAdminCreditsStatisticsActionType(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StatisticsApiApiStatisticsApiGetAdminEmailStatisticsByTypeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetAdminEmailStatisticsByType(requestParameters: StatisticsApiApiStatisticsApiGetAdminEmailStatisticsByTypeRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetAdminEmailStatisticsResponse> {
            return localVarFp.statisticsApiGetAdminEmailStatisticsByType(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StatisticsApiApiStatisticsApiGetAdminExternalJobStatisticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetAdminExternalJobStatistics(requestParameters: StatisticsApiApiStatisticsApiGetAdminExternalJobStatisticsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetAdminExternalJobStatisticsResponse> {
            return localVarFp.statisticsApiGetAdminExternalJobStatistics(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StatisticsApiApiStatisticsApiGetAdminGemsStatisticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetAdminGemsStatistics(requestParameters: StatisticsApiApiStatisticsApiGetAdminGemsStatisticsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetAdminGemsStatisticsResponse> {
            return localVarFp.statisticsApiGetAdminGemsStatistics(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StatisticsApiApiStatisticsApiGetAdminJobChatStatisticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetAdminJobChatStatistics(requestParameters: StatisticsApiApiStatisticsApiGetAdminJobChatStatisticsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetAdminJobChatStatisticsResponse> {
            return localVarFp.statisticsApiGetAdminJobChatStatistics(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StatisticsApiApiStatisticsApiGetAdminJobPostedStatisticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetAdminJobPostedStatistics(requestParameters: StatisticsApiApiStatisticsApiGetAdminJobPostedStatisticsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetAdminJobPostedStatisticsResponse> {
            return localVarFp.statisticsApiGetAdminJobPostedStatistics(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StatisticsApiApiStatisticsApiGetAdminJobProfileInvitesStatisticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetAdminJobProfileInvitesStatistics(requestParameters: StatisticsApiApiStatisticsApiGetAdminJobProfileInvitesStatisticsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetAdminJobProfileInvitesStatisticsResponse> {
            return localVarFp.statisticsApiGetAdminJobProfileInvitesStatistics(requestParameters.endDate, requestParameters.granularity, requestParameters.jobId, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StatisticsApiApiStatisticsApiGetAdminJobStatisticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetAdminJobStatistics(requestParameters: StatisticsApiApiStatisticsApiGetAdminJobStatisticsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetAdminJobStatisticsResponse> {
            return localVarFp.statisticsApiGetAdminJobStatistics(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StatisticsApiApiStatisticsApiGetAdminLearnerActivityStatisticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetAdminLearnerActivityStatistics(requestParameters: StatisticsApiApiStatisticsApiGetAdminLearnerActivityStatisticsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<LearnerActivityStatisticsResponse> {
            return localVarFp.statisticsApiGetAdminLearnerActivityStatistics(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StatisticsApiApiStatisticsApiGetAdminOtpFunnelStatisticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetAdminOtpFunnelStatistics(requestParameters: StatisticsApiApiStatisticsApiGetAdminOtpFunnelStatisticsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<OtpFunnelStatisticsResponse> {
            return localVarFp.statisticsApiGetAdminOtpFunnelStatistics(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StatisticsApiApiStatisticsApiGetAdminPaymentFunnelStatisticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetAdminPaymentFunnelStatistics(requestParameters: StatisticsApiApiStatisticsApiGetAdminPaymentFunnelStatisticsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaymentFunnelStatisticsResponse> {
            return localVarFp.statisticsApiGetAdminPaymentFunnelStatistics(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StatisticsApiApiStatisticsApiGetAdminPlacementPartnerStatisticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetAdminPlacementPartnerStatistics(requestParameters: StatisticsApiApiStatisticsApiGetAdminPlacementPartnerStatisticsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetAdminPlacementPartnerStatisticsResponse> {
            return localVarFp.statisticsApiGetAdminPlacementPartnerStatistics(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StatisticsApiApiStatisticsApiGetAdminPlayArenaStatisticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetAdminPlayArenaStatistics(requestParameters: StatisticsApiApiStatisticsApiGetAdminPlayArenaStatisticsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PlayArenaStatisticsResponse> {
            return localVarFp.statisticsApiGetAdminPlayArenaStatistics(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StatisticsApiApiStatisticsApiGetAdminPreJobAnalysisStatisticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetAdminPreJobAnalysisStatistics(requestParameters: StatisticsApiApiStatisticsApiGetAdminPreJobAnalysisStatisticsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetAdminPreJobAnalysisStatisticsResponse> {
            return localVarFp.statisticsApiGetAdminPreJobAnalysisStatistics(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StatisticsApiApiStatisticsApiGetAdminPremiumSubscriptionStatisticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetAdminPremiumSubscriptionStatistics(requestParameters: StatisticsApiApiStatisticsApiGetAdminPremiumSubscriptionStatisticsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PremiumSubscriptionStatisticsResponse> {
            return localVarFp.statisticsApiGetAdminPremiumSubscriptionStatistics(requestParameters.endDate, requestParameters.granularity, requestParameters.introOffer, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StatisticsApiApiStatisticsApiGetAdminQuestionCreatedStatisticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetAdminQuestionCreatedStatistics(requestParameters: StatisticsApiApiStatisticsApiGetAdminQuestionCreatedStatisticsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetAdminQuestionCreatedStatisticsResponse> {
            return localVarFp.statisticsApiGetAdminQuestionCreatedStatistics(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StatisticsApiApiStatisticsApiGetAdminQuestionStatisticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetAdminQuestionStatistics(requestParameters: StatisticsApiApiStatisticsApiGetAdminQuestionStatisticsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetAdminQuestionAttemptStatisticsResponse> {
            return localVarFp.statisticsApiGetAdminQuestionStatistics(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StatisticsApiApiStatisticsApiGetAdminReferralStatisticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetAdminReferralStatistics(requestParameters: StatisticsApiApiStatisticsApiGetAdminReferralStatisticsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetAdminReferralStatisticsResponse> {
            return localVarFp.statisticsApiGetAdminReferralStatistics(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StatisticsApiApiStatisticsApiGetAdminResumeStatisticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetAdminResumeStatistics(requestParameters: StatisticsApiApiStatisticsApiGetAdminResumeStatisticsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetAdminResumeStatisticsResponse> {
            return localVarFp.statisticsApiGetAdminResumeStatistics(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StatisticsApiApiStatisticsApiGetAdminSkillTestStatisticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetAdminSkillTestStatistics(requestParameters: StatisticsApiApiStatisticsApiGetAdminSkillTestStatisticsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetAdminSkilltestStatisticsResponse> {
            return localVarFp.statisticsApiGetAdminSkillTestStatistics(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StatisticsApiApiStatisticsApiGetAlgoLogsActivityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetAlgoLogsActivity(requestParameters: StatisticsApiApiStatisticsApiGetAlgoLogsActivityRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetAlgoLogsStatisticsResponse> {
            return localVarFp.statisticsApiGetAlgoLogsActivity(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StatisticsApiApiStatisticsApiGetEmployerActivityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetEmployerActivity(requestParameters: StatisticsApiApiStatisticsApiGetEmployerActivityRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<EmployerStatisticsResponse> {
            return localVarFp.statisticsApiGetEmployerActivity(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StatisticsApiApiStatisticsApiGetJobApplicantsSummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetJobApplicantsSummary(requestParameters: StatisticsApiApiStatisticsApiGetJobApplicantsSummaryRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<JobApplicantsStatistics> {
            return localVarFp.statisticsApiGetJobApplicantsSummary(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StatisticsApiApiStatisticsApiGetUserSignupsByPageUrlRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetUserSignupsByPageUrl(requestParameters: StatisticsApiApiStatisticsApiGetUserSignupsByPageUrlRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SignupPageStatistics> {
            return localVarFp.statisticsApiGetUserSignupsByPageUrl(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StatisticsApiApiStatisticsApiGetUserSignupsByUtmSourceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsApiGetUserSignupsByUtmSource(requestParameters: StatisticsApiApiStatisticsApiGetUserSignupsByUtmSourceRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SignupStatistics> {
            return localVarFp.statisticsApiGetUserSignupsByUtmSource(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for statisticsApiGetAdminAiGuideStatistics operation in StatisticsApiApi.
 */
export interface StatisticsApiApiStatisticsApiGetAdminAiGuideStatisticsRequest {
    readonly endDate?: string

    readonly granularity?: string

    readonly platform?: string

    readonly startDate?: string

    readonly userType?: string
}

/**
 * Request parameters for statisticsApiGetAdminAiUsageStatistics operation in StatisticsApiApi.
 */
export interface StatisticsApiApiStatisticsApiGetAdminAiUsageStatisticsRequest {
    readonly endDate?: string

    readonly granularity?: string

    readonly platform?: string

    readonly startDate?: string

    readonly userType?: string
}

/**
 * Request parameters for statisticsApiGetAdminChatStatistics operation in StatisticsApiApi.
 */
export interface StatisticsApiApiStatisticsApiGetAdminChatStatisticsRequest {
    readonly endDate?: string

    readonly granularity?: string

    readonly platform?: string

    readonly startDate?: string

    readonly userType?: string
}

/**
 * Request parameters for statisticsApiGetAdminCompetitionStatistics operation in StatisticsApiApi.
 */
export interface StatisticsApiApiStatisticsApiGetAdminCompetitionStatisticsRequest {
    readonly endDate?: string

    readonly granularity?: string

    readonly platform?: string

    readonly startDate?: string

    readonly userType?: string
}

/**
 * Request parameters for statisticsApiGetAdminCreditsStatistics operation in StatisticsApiApi.
 */
export interface StatisticsApiApiStatisticsApiGetAdminCreditsStatisticsRequest {
    readonly endDate?: string

    readonly granularity?: string

    readonly platform?: string

    readonly startDate?: string

    readonly userType?: string
}

/**
 * Request parameters for statisticsApiGetAdminCreditsStatisticsActionType operation in StatisticsApiApi.
 */
export interface StatisticsApiApiStatisticsApiGetAdminCreditsStatisticsActionTypeRequest {
    readonly endDate?: string

    readonly granularity?: string

    readonly platform?: string

    readonly startDate?: string

    readonly userType?: string
}

/**
 * Request parameters for statisticsApiGetAdminEmailStatisticsByType operation in StatisticsApiApi.
 */
export interface StatisticsApiApiStatisticsApiGetAdminEmailStatisticsByTypeRequest {
    readonly endDate?: string

    readonly granularity?: string

    readonly platform?: string

    readonly startDate?: string

    readonly userType?: string
}

/**
 * Request parameters for statisticsApiGetAdminExternalJobStatistics operation in StatisticsApiApi.
 */
export interface StatisticsApiApiStatisticsApiGetAdminExternalJobStatisticsRequest {
    readonly endDate?: string

    readonly granularity?: string

    readonly platform?: string

    readonly startDate?: string

    readonly userType?: string
}

/**
 * Request parameters for statisticsApiGetAdminGemsStatistics operation in StatisticsApiApi.
 */
export interface StatisticsApiApiStatisticsApiGetAdminGemsStatisticsRequest {
    readonly endDate?: string

    readonly granularity?: string

    readonly platform?: string

    readonly startDate?: string

    readonly userType?: string
}

/**
 * Request parameters for statisticsApiGetAdminJobChatStatistics operation in StatisticsApiApi.
 */
export interface StatisticsApiApiStatisticsApiGetAdminJobChatStatisticsRequest {
    readonly endDate?: string

    readonly granularity?: string

    readonly platform?: string

    readonly startDate?: string

    readonly userType?: string
}

/**
 * Request parameters for statisticsApiGetAdminJobPostedStatistics operation in StatisticsApiApi.
 */
export interface StatisticsApiApiStatisticsApiGetAdminJobPostedStatisticsRequest {
    readonly endDate?: string

    readonly granularity?: string

    readonly platform?: string

    readonly startDate?: string

    readonly userType?: string
}

/**
 * Request parameters for statisticsApiGetAdminJobProfileInvitesStatistics operation in StatisticsApiApi.
 */
export interface StatisticsApiApiStatisticsApiGetAdminJobProfileInvitesStatisticsRequest {
    readonly endDate?: string

    readonly granularity?: string

    readonly jobId?: string

    readonly platform?: string

    readonly startDate?: string

    readonly userType?: string
}

/**
 * Request parameters for statisticsApiGetAdminJobStatistics operation in StatisticsApiApi.
 */
export interface StatisticsApiApiStatisticsApiGetAdminJobStatisticsRequest {
    readonly endDate?: string

    readonly granularity?: string

    readonly platform?: string

    readonly startDate?: string

    readonly userType?: string
}

/**
 * Request parameters for statisticsApiGetAdminLearnerActivityStatistics operation in StatisticsApiApi.
 */
export interface StatisticsApiApiStatisticsApiGetAdminLearnerActivityStatisticsRequest {
    readonly endDate?: string

    readonly granularity?: string

    readonly platform?: string

    readonly startDate?: string

    readonly userType?: string
}

/**
 * Request parameters for statisticsApiGetAdminOtpFunnelStatistics operation in StatisticsApiApi.
 */
export interface StatisticsApiApiStatisticsApiGetAdminOtpFunnelStatisticsRequest {
    readonly endDate?: string

    readonly granularity?: string

    readonly platform?: string

    readonly startDate?: string

    readonly userType?: string
}

/**
 * Request parameters for statisticsApiGetAdminPaymentFunnelStatistics operation in StatisticsApiApi.
 */
export interface StatisticsApiApiStatisticsApiGetAdminPaymentFunnelStatisticsRequest {
    readonly endDate?: string

    readonly granularity?: string

    readonly platform?: string

    readonly startDate?: string

    readonly userType?: string
}

/**
 * Request parameters for statisticsApiGetAdminPlacementPartnerStatistics operation in StatisticsApiApi.
 */
export interface StatisticsApiApiStatisticsApiGetAdminPlacementPartnerStatisticsRequest {
    readonly endDate?: string

    readonly granularity?: string

    readonly platform?: string

    readonly startDate?: string

    readonly userType?: string
}

/**
 * Request parameters for statisticsApiGetAdminPlayArenaStatistics operation in StatisticsApiApi.
 */
export interface StatisticsApiApiStatisticsApiGetAdminPlayArenaStatisticsRequest {
    readonly endDate?: string

    readonly granularity?: string

    readonly platform?: string

    readonly startDate?: string

    readonly userType?: string
}

/**
 * Request parameters for statisticsApiGetAdminPreJobAnalysisStatistics operation in StatisticsApiApi.
 */
export interface StatisticsApiApiStatisticsApiGetAdminPreJobAnalysisStatisticsRequest {
    readonly endDate?: string

    readonly granularity?: string

    readonly platform?: string

    readonly startDate?: string

    readonly userType?: string
}

/**
 * Request parameters for statisticsApiGetAdminPremiumSubscriptionStatistics operation in StatisticsApiApi.
 */
export interface StatisticsApiApiStatisticsApiGetAdminPremiumSubscriptionStatisticsRequest {
    readonly endDate?: string

    readonly granularity?: string

    readonly introOffer?: StatisticsApiGetAdminPremiumSubscriptionStatisticsIntroOfferEnum

    readonly platform?: string

    readonly startDate?: string

    readonly userType?: string
}

/**
 * Request parameters for statisticsApiGetAdminQuestionCreatedStatistics operation in StatisticsApiApi.
 */
export interface StatisticsApiApiStatisticsApiGetAdminQuestionCreatedStatisticsRequest {
    readonly endDate?: string

    readonly granularity?: string

    readonly platform?: string

    readonly startDate?: string

    readonly userType?: string
}

/**
 * Request parameters for statisticsApiGetAdminQuestionStatistics operation in StatisticsApiApi.
 */
export interface StatisticsApiApiStatisticsApiGetAdminQuestionStatisticsRequest {
    readonly endDate?: string

    readonly granularity?: string

    readonly platform?: string

    readonly startDate?: string

    readonly userType?: string
}

/**
 * Request parameters for statisticsApiGetAdminReferralStatistics operation in StatisticsApiApi.
 */
export interface StatisticsApiApiStatisticsApiGetAdminReferralStatisticsRequest {
    readonly endDate?: string

    readonly granularity?: string

    readonly platform?: string

    readonly startDate?: string

    readonly userType?: string
}

/**
 * Request parameters for statisticsApiGetAdminResumeStatistics operation in StatisticsApiApi.
 */
export interface StatisticsApiApiStatisticsApiGetAdminResumeStatisticsRequest {
    readonly endDate?: string

    readonly granularity?: string

    readonly platform?: string

    readonly startDate?: string

    readonly userType?: string
}

/**
 * Request parameters for statisticsApiGetAdminSkillTestStatistics operation in StatisticsApiApi.
 */
export interface StatisticsApiApiStatisticsApiGetAdminSkillTestStatisticsRequest {
    readonly endDate?: string

    readonly granularity?: string

    readonly platform?: string

    readonly startDate?: string

    readonly userType?: string
}

/**
 * Request parameters for statisticsApiGetAlgoLogsActivity operation in StatisticsApiApi.
 */
export interface StatisticsApiApiStatisticsApiGetAlgoLogsActivityRequest {
    readonly endDate?: string

    readonly granularity?: string

    readonly platform?: string

    readonly startDate?: string

    readonly userType?: string
}

/**
 * Request parameters for statisticsApiGetEmployerActivity operation in StatisticsApiApi.
 */
export interface StatisticsApiApiStatisticsApiGetEmployerActivityRequest {
    readonly endDate?: string

    readonly granularity?: string

    readonly platform?: string

    readonly startDate?: string

    readonly userType?: string
}

/**
 * Request parameters for statisticsApiGetJobApplicantsSummary operation in StatisticsApiApi.
 */
export interface StatisticsApiApiStatisticsApiGetJobApplicantsSummaryRequest {
    readonly endDate?: string

    readonly granularity?: string

    readonly platform?: string

    readonly startDate?: string

    readonly userType?: string
}

/**
 * Request parameters for statisticsApiGetUserSignupsByPageUrl operation in StatisticsApiApi.
 */
export interface StatisticsApiApiStatisticsApiGetUserSignupsByPageUrlRequest {
    readonly endDate?: string

    readonly granularity?: string

    readonly platform?: string

    readonly startDate?: string

    readonly userType?: string
}

/**
 * Request parameters for statisticsApiGetUserSignupsByUtmSource operation in StatisticsApiApi.
 */
export interface StatisticsApiApiStatisticsApiGetUserSignupsByUtmSourceRequest {
    readonly endDate?: string

    readonly granularity?: string

    readonly platform?: string

    readonly startDate?: string

    readonly userType?: string
}

/**
 * StatisticsApiApi - object-oriented interface
 */
export class StatisticsApiApi extends BaseAPI {
    /**
     * 
     * @param {StatisticsApiApiStatisticsApiGetAdminAiGuideStatisticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public statisticsApiGetAdminAiGuideStatistics(requestParameters: StatisticsApiApiStatisticsApiGetAdminAiGuideStatisticsRequest = {}, options?: RawAxiosRequestConfig) {
        return StatisticsApiApiFp(this.configuration).statisticsApiGetAdminAiGuideStatistics(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StatisticsApiApiStatisticsApiGetAdminAiUsageStatisticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public statisticsApiGetAdminAiUsageStatistics(requestParameters: StatisticsApiApiStatisticsApiGetAdminAiUsageStatisticsRequest = {}, options?: RawAxiosRequestConfig) {
        return StatisticsApiApiFp(this.configuration).statisticsApiGetAdminAiUsageStatistics(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StatisticsApiApiStatisticsApiGetAdminChatStatisticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public statisticsApiGetAdminChatStatistics(requestParameters: StatisticsApiApiStatisticsApiGetAdminChatStatisticsRequest = {}, options?: RawAxiosRequestConfig) {
        return StatisticsApiApiFp(this.configuration).statisticsApiGetAdminChatStatistics(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StatisticsApiApiStatisticsApiGetAdminCompetitionStatisticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public statisticsApiGetAdminCompetitionStatistics(requestParameters: StatisticsApiApiStatisticsApiGetAdminCompetitionStatisticsRequest = {}, options?: RawAxiosRequestConfig) {
        return StatisticsApiApiFp(this.configuration).statisticsApiGetAdminCompetitionStatistics(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StatisticsApiApiStatisticsApiGetAdminCreditsStatisticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public statisticsApiGetAdminCreditsStatistics(requestParameters: StatisticsApiApiStatisticsApiGetAdminCreditsStatisticsRequest = {}, options?: RawAxiosRequestConfig) {
        return StatisticsApiApiFp(this.configuration).statisticsApiGetAdminCreditsStatistics(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StatisticsApiApiStatisticsApiGetAdminCreditsStatisticsActionTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public statisticsApiGetAdminCreditsStatisticsActionType(requestParameters: StatisticsApiApiStatisticsApiGetAdminCreditsStatisticsActionTypeRequest = {}, options?: RawAxiosRequestConfig) {
        return StatisticsApiApiFp(this.configuration).statisticsApiGetAdminCreditsStatisticsActionType(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StatisticsApiApiStatisticsApiGetAdminEmailStatisticsByTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public statisticsApiGetAdminEmailStatisticsByType(requestParameters: StatisticsApiApiStatisticsApiGetAdminEmailStatisticsByTypeRequest = {}, options?: RawAxiosRequestConfig) {
        return StatisticsApiApiFp(this.configuration).statisticsApiGetAdminEmailStatisticsByType(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StatisticsApiApiStatisticsApiGetAdminExternalJobStatisticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public statisticsApiGetAdminExternalJobStatistics(requestParameters: StatisticsApiApiStatisticsApiGetAdminExternalJobStatisticsRequest = {}, options?: RawAxiosRequestConfig) {
        return StatisticsApiApiFp(this.configuration).statisticsApiGetAdminExternalJobStatistics(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StatisticsApiApiStatisticsApiGetAdminGemsStatisticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public statisticsApiGetAdminGemsStatistics(requestParameters: StatisticsApiApiStatisticsApiGetAdminGemsStatisticsRequest = {}, options?: RawAxiosRequestConfig) {
        return StatisticsApiApiFp(this.configuration).statisticsApiGetAdminGemsStatistics(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StatisticsApiApiStatisticsApiGetAdminJobChatStatisticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public statisticsApiGetAdminJobChatStatistics(requestParameters: StatisticsApiApiStatisticsApiGetAdminJobChatStatisticsRequest = {}, options?: RawAxiosRequestConfig) {
        return StatisticsApiApiFp(this.configuration).statisticsApiGetAdminJobChatStatistics(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StatisticsApiApiStatisticsApiGetAdminJobPostedStatisticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public statisticsApiGetAdminJobPostedStatistics(requestParameters: StatisticsApiApiStatisticsApiGetAdminJobPostedStatisticsRequest = {}, options?: RawAxiosRequestConfig) {
        return StatisticsApiApiFp(this.configuration).statisticsApiGetAdminJobPostedStatistics(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StatisticsApiApiStatisticsApiGetAdminJobProfileInvitesStatisticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public statisticsApiGetAdminJobProfileInvitesStatistics(requestParameters: StatisticsApiApiStatisticsApiGetAdminJobProfileInvitesStatisticsRequest = {}, options?: RawAxiosRequestConfig) {
        return StatisticsApiApiFp(this.configuration).statisticsApiGetAdminJobProfileInvitesStatistics(requestParameters.endDate, requestParameters.granularity, requestParameters.jobId, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StatisticsApiApiStatisticsApiGetAdminJobStatisticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public statisticsApiGetAdminJobStatistics(requestParameters: StatisticsApiApiStatisticsApiGetAdminJobStatisticsRequest = {}, options?: RawAxiosRequestConfig) {
        return StatisticsApiApiFp(this.configuration).statisticsApiGetAdminJobStatistics(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StatisticsApiApiStatisticsApiGetAdminLearnerActivityStatisticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public statisticsApiGetAdminLearnerActivityStatistics(requestParameters: StatisticsApiApiStatisticsApiGetAdminLearnerActivityStatisticsRequest = {}, options?: RawAxiosRequestConfig) {
        return StatisticsApiApiFp(this.configuration).statisticsApiGetAdminLearnerActivityStatistics(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StatisticsApiApiStatisticsApiGetAdminOtpFunnelStatisticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public statisticsApiGetAdminOtpFunnelStatistics(requestParameters: StatisticsApiApiStatisticsApiGetAdminOtpFunnelStatisticsRequest = {}, options?: RawAxiosRequestConfig) {
        return StatisticsApiApiFp(this.configuration).statisticsApiGetAdminOtpFunnelStatistics(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StatisticsApiApiStatisticsApiGetAdminPaymentFunnelStatisticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public statisticsApiGetAdminPaymentFunnelStatistics(requestParameters: StatisticsApiApiStatisticsApiGetAdminPaymentFunnelStatisticsRequest = {}, options?: RawAxiosRequestConfig) {
        return StatisticsApiApiFp(this.configuration).statisticsApiGetAdminPaymentFunnelStatistics(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StatisticsApiApiStatisticsApiGetAdminPlacementPartnerStatisticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public statisticsApiGetAdminPlacementPartnerStatistics(requestParameters: StatisticsApiApiStatisticsApiGetAdminPlacementPartnerStatisticsRequest = {}, options?: RawAxiosRequestConfig) {
        return StatisticsApiApiFp(this.configuration).statisticsApiGetAdminPlacementPartnerStatistics(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StatisticsApiApiStatisticsApiGetAdminPlayArenaStatisticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public statisticsApiGetAdminPlayArenaStatistics(requestParameters: StatisticsApiApiStatisticsApiGetAdminPlayArenaStatisticsRequest = {}, options?: RawAxiosRequestConfig) {
        return StatisticsApiApiFp(this.configuration).statisticsApiGetAdminPlayArenaStatistics(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StatisticsApiApiStatisticsApiGetAdminPreJobAnalysisStatisticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public statisticsApiGetAdminPreJobAnalysisStatistics(requestParameters: StatisticsApiApiStatisticsApiGetAdminPreJobAnalysisStatisticsRequest = {}, options?: RawAxiosRequestConfig) {
        return StatisticsApiApiFp(this.configuration).statisticsApiGetAdminPreJobAnalysisStatistics(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StatisticsApiApiStatisticsApiGetAdminPremiumSubscriptionStatisticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public statisticsApiGetAdminPremiumSubscriptionStatistics(requestParameters: StatisticsApiApiStatisticsApiGetAdminPremiumSubscriptionStatisticsRequest = {}, options?: RawAxiosRequestConfig) {
        return StatisticsApiApiFp(this.configuration).statisticsApiGetAdminPremiumSubscriptionStatistics(requestParameters.endDate, requestParameters.granularity, requestParameters.introOffer, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StatisticsApiApiStatisticsApiGetAdminQuestionCreatedStatisticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public statisticsApiGetAdminQuestionCreatedStatistics(requestParameters: StatisticsApiApiStatisticsApiGetAdminQuestionCreatedStatisticsRequest = {}, options?: RawAxiosRequestConfig) {
        return StatisticsApiApiFp(this.configuration).statisticsApiGetAdminQuestionCreatedStatistics(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StatisticsApiApiStatisticsApiGetAdminQuestionStatisticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public statisticsApiGetAdminQuestionStatistics(requestParameters: StatisticsApiApiStatisticsApiGetAdminQuestionStatisticsRequest = {}, options?: RawAxiosRequestConfig) {
        return StatisticsApiApiFp(this.configuration).statisticsApiGetAdminQuestionStatistics(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StatisticsApiApiStatisticsApiGetAdminReferralStatisticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public statisticsApiGetAdminReferralStatistics(requestParameters: StatisticsApiApiStatisticsApiGetAdminReferralStatisticsRequest = {}, options?: RawAxiosRequestConfig) {
        return StatisticsApiApiFp(this.configuration).statisticsApiGetAdminReferralStatistics(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StatisticsApiApiStatisticsApiGetAdminResumeStatisticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public statisticsApiGetAdminResumeStatistics(requestParameters: StatisticsApiApiStatisticsApiGetAdminResumeStatisticsRequest = {}, options?: RawAxiosRequestConfig) {
        return StatisticsApiApiFp(this.configuration).statisticsApiGetAdminResumeStatistics(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StatisticsApiApiStatisticsApiGetAdminSkillTestStatisticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public statisticsApiGetAdminSkillTestStatistics(requestParameters: StatisticsApiApiStatisticsApiGetAdminSkillTestStatisticsRequest = {}, options?: RawAxiosRequestConfig) {
        return StatisticsApiApiFp(this.configuration).statisticsApiGetAdminSkillTestStatistics(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StatisticsApiApiStatisticsApiGetAlgoLogsActivityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public statisticsApiGetAlgoLogsActivity(requestParameters: StatisticsApiApiStatisticsApiGetAlgoLogsActivityRequest = {}, options?: RawAxiosRequestConfig) {
        return StatisticsApiApiFp(this.configuration).statisticsApiGetAlgoLogsActivity(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StatisticsApiApiStatisticsApiGetEmployerActivityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public statisticsApiGetEmployerActivity(requestParameters: StatisticsApiApiStatisticsApiGetEmployerActivityRequest = {}, options?: RawAxiosRequestConfig) {
        return StatisticsApiApiFp(this.configuration).statisticsApiGetEmployerActivity(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StatisticsApiApiStatisticsApiGetJobApplicantsSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public statisticsApiGetJobApplicantsSummary(requestParameters: StatisticsApiApiStatisticsApiGetJobApplicantsSummaryRequest = {}, options?: RawAxiosRequestConfig) {
        return StatisticsApiApiFp(this.configuration).statisticsApiGetJobApplicantsSummary(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StatisticsApiApiStatisticsApiGetUserSignupsByPageUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public statisticsApiGetUserSignupsByPageUrl(requestParameters: StatisticsApiApiStatisticsApiGetUserSignupsByPageUrlRequest = {}, options?: RawAxiosRequestConfig) {
        return StatisticsApiApiFp(this.configuration).statisticsApiGetUserSignupsByPageUrl(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StatisticsApiApiStatisticsApiGetUserSignupsByUtmSourceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public statisticsApiGetUserSignupsByUtmSource(requestParameters: StatisticsApiApiStatisticsApiGetUserSignupsByUtmSourceRequest = {}, options?: RawAxiosRequestConfig) {
        return StatisticsApiApiFp(this.configuration).statisticsApiGetUserSignupsByUtmSource(requestParameters.endDate, requestParameters.granularity, requestParameters.platform, requestParameters.startDate, requestParameters.userType, options).then((request) => request(this.axios, this.basePath));
    }
}

export const StatisticsApiGetAdminPremiumSubscriptionStatisticsIntroOfferEnum = {
    FreeMonth: 'free_month',
    Free7d: 'free_7d',
    DealFirstMonth: 'deal_first_month',
} as const;
export type StatisticsApiGetAdminPremiumSubscriptionStatisticsIntroOfferEnum = typeof StatisticsApiGetAdminPremiumSubscriptionStatisticsIntroOfferEnum[keyof typeof StatisticsApiGetAdminPremiumSubscriptionStatisticsIntroOfferEnum];
